import classNames from "classnames"
import React from "react"
import { useLabels } from "../../../features/contents/hooks"
import { ArrowDownIcon, ArrowUpIcon } from "../../icons"
import classes from "./ExpandableText.module.css"

export interface ExpandableTextProps {
  defaultExpanded?: boolean
  disabled?: boolean
  children: React.ReactNode
}

const ExpandableText = ({
  defaultExpanded,
  disabled,
  children,
}: ExpandableTextProps) => {
  const [expanded, setExpanded] = React.useState(defaultExpanded ?? false)
  const { getLabel } = useLabels()

  if (disabled) {
    return <>{children}</>
  }

  return (
    <div
      className={classNames(classes.root, {
        [classes.collapsed]: !expanded,
        [classes.expanded]: expanded,
      })}
    >
      {children}
      <div className={classes.control} onClick={() => setExpanded(!expanded)}>
        {expanded ? (
          <div className={classes.toggle}>
            <div className="mr-2">{getLabel("common", "hide")}</div>{" "}
            <ArrowUpIcon />
          </div>
        ) : (
          <div className={classes.toggle}>
            <div className="mr-2">{getLabel("common", "read-more")}</div>{" "}
            <ArrowDownIcon />
          </div>
        )}
      </div>
    </div>
  )
}

export default ExpandableText
